/*
 * 2016 sitegeist media solutions GmbH
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of sitegeist media solutions GmbH and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to sitegeist media solutions GmbH
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from sitegeist media solutions GmbH.
 *
 */

/** @jsx h */

import {h, render, Component} from 'preact';
import mergeClassnames from 'classnames';

import Lighbox from '../Lightbox/index';

import Frame from './Frame/index';
import Pagination from './Pagination/index';

export default class GalleryLightbox extends Component {
	state = {current: 1};

	componentDidMount() {
		const {trigger} = this.props;
		trigger.forEach((o, i) => o.addEventListener('click', () => this.setState({current: i+1})));
	}

	renderDescription(imageData) {
		const {description} = imageData;

		if (description === 'Parfümerie Wiedemann') {
			return <a href="http://www.parfuemerie-wiedemann.de/" target="_blank" rel="noopener">
				<strong>{description}</strong>
			</a>;
		}

		return <strong>{description}</strong>;
	}

	render({images, label = 'Bild {current} von {total}'}) {
		const {current} = this.state;

		return (<div className="lightbox__gallery">
			<Frame image={images[current - 1].src} />
			{this.renderDescription(images[current - 1])}
			<Pagination
				current={current}
				total={images.length}
				label={label}
				onNavigatePrev={() => this.setState({current: current - 1})}
				onNavigateNext={() => this.setState({current: current + 1})}
				/>
		</div>);
	}
}
